import { registerClass } from '../SatCoreRegistry';

import userManager from '../managers/UserManager';

import { getSessionStorageItem, removeSessionStorageItem } from '../utils/session';

export const PRIVATE_PREVIEW_SESSION_KEY = 'c2c_privatePreviewContentItemId';

/**
 * PrivatePreviewService
 *
 * Shared helpers for the /privatePreview flow: after login, send teachers/admins
 * back to /privatePreview with the stashed contentItemId so the preview player can render.
 */
export default class PrivatePreviewService {
  static canUsePrivatePreview = () => {
    return !userManager.isStudent && userManager.canViewAsTeacher;
  }

  /**
   * If a pending /privatePreview contentItemId exists in sessionStorage, clear it and
   * (for teachers/admins only) redirect back to /privatePreview.
   * @returns {boolean} Whether a redirect was initiated
   */
  static redirectFromPendingPrivatePreviewIfApplicable = () => {
    const contentItemId = getSessionStorageItem(PRIVATE_PREVIEW_SESSION_KEY);
    if (!contentItemId) {
      return false;
    }

    removeSessionStorageItem(PRIVATE_PREVIEW_SESSION_KEY);

    if (!this.canUsePrivatePreview()) {
      console.info('[PrivatePreview] Pending preview skipped — user is not a teacher/admin');
      return false;
    }

    console.info('[PrivatePreview] Redirecting to pending private preview', { contentItemId });
    window.location.replace(`/privatePreview?contentItemId=${encodeURIComponent(contentItemId)}`);
    return true;
  }
}

registerClass('PrivatePreviewService', PrivatePreviewService);
